import type { ProductHit } from '@libs/algolia';
import type { Inventory } from '@libs/common-node';

const getUniqueProducts = (products: ProductHit[]) => {
    const uniqueIds = new Set();
    const filteredProducts = [];

    for (const product of products) {
        if (!uniqueIds.has(product.id)) {
            uniqueIds.add(product.id);
            filteredProducts.push(product);
        }
    }

    return filteredProducts;
};

export function mapStockDataToAlgoliaProducts(algoliaProducts: ProductHit[] = [], inventory: Inventory[] = []) {
    if (inventory.length < 1) {
        return [];
    }

    // This might not be needed?
    const uniqueAlgoliaProducts = getUniqueProducts(algoliaProducts);

    const stockTable =
        inventory?.reduce<Record<string, boolean>>((result, { sku, ...stores }) => {
            const hasInventory = Object.values(stores).some(inventory => (inventory as number) >= 1);
            if (hasInventory) {
                result[sku] = true;
            }
            return result;
        }, {}) ?? {};

    return uniqueAlgoliaProducts.map(algoliaProduct => ({
        ...algoliaProduct,
        in_stock: Boolean(stockTable[algoliaProduct.id]),
    }));
}
